module.exports = __webpack_public_path__ + "img/france_flag.5ca5eb09.png";